import { COLORS } from 'consts/colors'

interface IAudioItemColors {
  [key: string]: {
    backgroundColor: string
    draftBackgroundColor?: string
    waveColor: string
  }
}

export const AUDIO_ITEM_COLORS: IAudioItemColors = {
  VOICE_OVER: {
    backgroundColor: '#55A0FF',
    waveColor: '#3381f3'
  },
  TTS: {
    backgroundColor: '#BE54FF',
    draftBackgroundColor: COLORS.placeholder,
    waveColor: '#884cbd'
  },
  SOUND: {
    backgroundColor: '#8C83F7',
    waveColor: '#706ab7'
  }
}

export const AUDIO_TRACK_HEIGHT = 28
